import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { MenuItem } from '../model/menu-item';

export const adminMenuConfig: MenuItem[] = [
    { label: marker('header.admin-menu.pathways'), route: 'admin/pathways', testId: 'nav-admin-pathways' },
    { label: marker('header.admin-menu.students'), route: 'admin/learners', testId: 'nav-admin-learners' },
    { label: marker('header.admin-menu.licenses'), route: 'admin/licenses', testId: 'nav-admin-licenses' },
];
